// Packages
import PropTypes from 'prop-types'

// Components
import CustomerForm from 'modules/CustomerEquipment/components/Form';

// Other
import useApi from 'hooks/useApi';

const CustomerEquipmentEditScreen = ({  itemId, onClose, onSubmit }) => {

    const { data: item, put: updateItem, errors } = useApi('/customerequipment/' + itemId + '?with=customerequipmentscale');

	const submit = async (values) => {

        if( await updateItem(values, 'Customer equipment updated!')) {

            onSubmit();
        }
    }

    return(
        <CustomerForm 
            errors={errors} 
            customer_equipment={item} 
            onClose={onClose} 
            onSubmit={submit} 
            type='edit' 
        />
    )
}

CustomerEquipmentEditScreen.propTypes = {
    itemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	onClose: PropTypes.func,
    onSubmit: PropTypes.func,
}

CustomerEquipmentEditScreen.defaultProps = {
    itemId: null,
	onClose: () => {alert('onClose is not set!')},
    onSubmit: () => {alert('onSubmit is not set!')}
}

export default CustomerEquipmentEditScreen;